export function formatActivityLocation(activity) {
  if (!activity) {
    return null;
  }

  const name = typeof activity.location_name === "string" ? activity.location_name.trim() : "";
  if (name) {
    return name;
  }

  const rawParts = [
    activity.location_city,
    activity.location_state,
    activity.location_country
  ];

  const trimmed = rawParts
    .map((value) => (typeof value === "string" ? value.trim() : null))
    .filter(Boolean);

  if (trimmed.length === 0) {
    return null;
  }

  const seen = new Set();
  const orderedUnique = [];

  trimmed.forEach((part) => {
    const key = part.toLowerCase();
    if (!seen.has(key)) {
      seen.add(key);
      orderedUnique.push(part);
    }
  });

  return orderedUnique.join(", ") || null;
}

export default formatActivityLocation;
